import React from 'react'

const ComboNormal = ({original="dd",disabled=false, label="", name="", setComboValue=()=>{}, valores={}, values=[], id="", text="", defaultValue, fakeValue, required=false, tryToSave=false, estadoCompuesto = false}) => {
  console.log(original)
  console.log(values)
  return (
    <div className="flex flex-col w-full">
      <label className='text-white'>{label}</label>
      {/**
      <input disabled={disabled} className="text-black p-2 rounded-md" list={name} name={name} value={defaultValue} onChange={(e) => setComboValue(e.target.value)} //placeholder='Rol de usuario'
      />
       */}
      <select 
        id={name}
        className="text-black p-2 rounded-md"
        value={defaultValue}
        disabled={disabled} // poner otro prop para poner los values a enviar
        onChange={(e) => estadoCompuesto? setComboValue({...valores, [name]: e.target.value}):setComboValue(e.target.value)}
        >
        <option value={""}>{`--- Seleccione ${fakeValue}---`}</option>
        {values.length>0 && values?.map(rol => (
          <option value={rol[id]}>{rol[text]} {rol[id] == original? "✔" : ""}</option>
        ))}
      </select>
      {(tryToSave && required) && <p className='text-secundario'>Dato obligatorio</p>}
    </div>
  )
}

export default ComboNormal